import { render, staticRenderFns } from "./projectmanagement.vue?vue&type=template&id=cda614c4&scoped=true&"
import script from "./projectmanagement.vue?vue&type=script&lang=js&"
export * from "./projectmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda614c4",
  null
  
)

export default component.exports